/**
 * Volume Discount API - Product card badges
 * Fetches list of products with volume discounts and shows "Volume discounts available" on matching cards.
 */
(function () {
  const VOLUME_DISCOUNT_API_BASE = 'https://ctd-shipping.flogi.app';

  function run() {
    const badges = document.querySelectorAll('.volume-discount-badge[data-product-gid]');
    if (badges.length === 0) return;

    fetch(`${VOLUME_DISCOUNT_API_BASE}/api/volume-discounts-list`, {
      headers: { Accept: 'application/json' },
    })
      .then((res) => (res.ok ? res.json() : { success: false, products: [] }))
      .then((data) => {
        const productIds = new Set();
        if (data.success && Array.isArray(data.products)) {
          data.products.forEach((p) => {
            if (p.productId) productIds.add(p.productId);
          });
        }
        badges.forEach((el) => {
          const gid = el.getAttribute('data-product-gid');
          if (gid && productIds.has(gid)) {
            el.style.display = 'inline-flex';
          }
        });
      })
      .catch((err) => {
        console.warn('Volume discount badges API error:', err);
      });
  }

  function init() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 3000 });
    } else {
      setTimeout(run, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
